
































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { BillSearchResponse, BillOverviewResponse } from '@/models/billResponse';
import { EnabledTypes } from '@/enums/enabledTypes';
import { BillTypes } from '@/enums/billTypes';
import { BillStatusTypes, getBillStatusTypeName } from '@/enums/billStatusTypes';
import { getPaymentStatusTypeName, PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import Axios from 'axios';
import moment from 'moment';
import { BillSearchRequest } from '@/models/billRequest';
import { getGradeYearName } from '@/enums/gradeYears';
import { getReadTypeName, ReadTypes } from '@/enums/readTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({})
export default class BillList extends AvaivaledVue {
  private EnabledTypes = EnabledTypes;
  private BillTypes = BillTypes;
  private BillStatusTypes = BillStatusTypes;
  private getBillStatusTypeName = getBillStatusTypeName;
  private PaymentStatusTypes = PaymentStatusTypes;
  private getGradeYearName = getGradeYearName;
  private getReadTypeName = getReadTypeName;
  private ReadTypes = ReadTypes;

  private isLoading: boolean = false;
  private billList: BillOverviewResponse[] = [];
  private countAll: number = 0;

  private showSearchCondition = true;

  private checkedBillList: BillOverviewResponse[] = [];
  private checkChanging = false;

  get condition() {
    return this.$store.state.bill.billCondition;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }
  }

  public async mounted() {
    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.isLoading = true;
    this.checkChanging = true;

    try {
      const req: BillSearchRequest = {
        perPage: this.condition.perPage,
        page: this.condition.page,
        sort: this.condition.sort,
        enabled: this.condition.enabledType === EnabledTypes.None
          ? null
          : this.condition.enabledType === EnabledTypes.Enabled,
        billType: this.condition.billType || null,
        billStatus: this.condition.billStatus,
        paymentStatus: this.condition.paymentStatus || null,
        readType: this.condition.readType || null,
        billDateFrom: this.condition.billDateFrom,
        billDateTo: this.condition.billDateTo,
        billLimitDateFrom: this.condition.billLimitDateFrom,
        billLimitDateTo: this.condition.billLimitDateTo,
        ordinarySchoolId: this.condition.ordinarySchoolId,
        gradeYear: this.condition.gradeYear,
        tagList: this.condition.tagList,
        keyWord: this.condition.keyWord,
      };
      const res = await Axios.post<BillSearchResponse>('/api/bills', req);
      this.billList = res.data.bills.map((bill) => {
        let paymentStatus: PaymentStatusTypes;
        switch (bill.paymentStatus) {
          case PaymentStatusTypes.Paid:
          case PaymentStatusTypes.AutoPaid:
            paymentStatus = PaymentStatusTypes.Paid;
            break;
          default:
            paymentStatus = PaymentStatusTypes.Unpaid;
            break;
        }
        return {
          ...bill,
          paymentStatus,
        };
      });
      this.countAll = res.data.countAll;
    } catch (error) {
      this.billList = [];
    }

    this.$nextTick(() => {
      this.checkBills();
      this.checkChanging = false;
    });

    this.isLoading = false;
  }

  private checkBills() {
    const table = this.$refs.billTable as any;
    this.billList.forEach((row) => {
      if (!!this.checkedBillList.find((bill) => bill.billId === row.billId)) {
        table.toggleRowSelection(row, true);
      }
    });
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private getBillStatusTypeFormat(row: BillOverviewResponse) {
    const name = getBillStatusTypeName(row.billStatus);
    switch (row.billStatus) {
      case BillStatusTypes.Billed:
        return name;
    }

    return this.checkChargableBill(row)
      ? `${name}(請求可)`
      : `${name}(請求不可)`;
  }

  private checkChargableBill(row: BillOverviewResponse) {
    if (row.disabled) {
      return false;
    }

    if (row.billStatus === BillStatusTypes.Billed) {
      return false;
    }

    if (!row.billLimitDate) {
        // 決済日・支払期限が未設定
      return false;
    }

    const billLimitDate = moment(row.billLimitDate).format('YYYYMMDD');
    const now = moment().format('YYYYMMDD');
    if (billLimitDate < now) {
        // 決済日・支払期限が請求日より古い
        return false;
    }

    return true;
  }

  private getBillStatusTagType(row: BillOverviewResponse): string {
    switch (row.billStatus) {
      case BillStatusTypes.Billed:
        return 'success';
      case BillStatusTypes.Unbilled:
      default:
        return this.checkChargableBill(row) ? '' : 'danger';
    }
  }

  private getReadTypeTagType(readType: ReadTypes): string {
    switch (readType) {
      case ReadTypes.Read:
        return 'success';
      default:
        return 'danger';
    }
  }

  private onChangeSelection(selection: BillOverviewResponse[]) {
    if (this.checkChanging) { return; }
    this.billList.forEach((bill) => {
      if (!selection.find((value) => value.billId === bill.billId)) {
        const index = this.checkedBillList.findIndex((value) => value.billId === bill.billId);
        if (index >= 0) {
          this.checkedBillList.splice(index, 1);
        }
      }
    });
    const addBills = selection.filter((student) => {
      return !this.checkedBillList.find((value) => value.billId === student.billId);
    });
    if (addBills.length > 0) {
      this.checkedBillList.push(...addBills);
    }
  }

  private clearCheckedBill() {
    this.checkedBillList.splice(0, this.checkedBillList.length);
    const table = this.$refs.billTable as any;
    table.clearSelection();
  }

  private checkdBillClose(billId: string) {
    const index = this.checkedBillList.findIndex((value) => value.billId === billId);
    if (index >= 0) {
      this.checkedBillList.splice(index, 1);
    }

    const row = this.billList.find((value) => value.billId === billId);
    if (!!row) {
      const table = this.$refs.billTable as any;
      table.toggleRowSelection(row, false);
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: BillOverviewResponse, column: any) {
    switch (column.property) {
      case 'check':
      case 'paymentStatus':
      case 'isPeriodic':
        return;
    }
    this.$router.push(`/bill/bills/${row.billId}`);
  }

  private onViewPeriodicBill(periodicBillId: string) {
    this.$router.push(`/bill/periodic-bills/${periodicBillId}`);
  }

  private onCreateBill() {
    this.$router.push('/bill/bills/create');
  }

  private async onBulkChargeBill() {
    const targetBillList = this.checkedBillList
      .filter((billData) => this.checkChargableBill(billData));

    if (targetBillList.length === 0) {
      this.$notify.error({
        title: '一括請求作成エラー',
        message: '請求可能な請求書が選択されていません。',
        position: 'bottom-right'
      });
      return;
    }

    try {
      const nowString = moment(new Date()).format('YYYY年MM月DD日');
      const message = targetBillList.length < this.checkedBillList.length
        ? `選択中の内、請求可能な請求書（${targetBillList.length}件）を請求します。よろしいですか？<br>請求日が本日（${nowString}）になります。`
        : `選択中の請求書（${targetBillList.length}件）を請求します。よろしいですか？<br>請求日が本日（${nowString}）になります。`;

      await this.$confirm(message, '一括請求確認', {
        confirmButtonText: '一括請求',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      await Axios.post('/api/bills/bulk-charge-bill', {
        billIds: targetBillList.map((item) => item.billId),
      });

      this.clearCheckedBill();

      this.$notify.success({
        title: '一括請求完了',
        message: '一括請求しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '一括請求エラー',
        message:
          (error.response && error.response.data) || '一括請求が失敗しました。',
        position: 'bottom-right',
      });
    }

    this.loadData();
  }

  private async onBulkPaymentBill() {
    const targetBillList = this.checkedBillList
      .filter((billData) => !billData.disabled
          && billData.billType !== BillTypes.Creditcard
          && billData.billStatus === BillStatusTypes.Billed
          && (
            billData.paymentStatus !== PaymentStatusTypes.Paid
            && billData.paymentStatus !== PaymentStatusTypes.AutoPaid
          ));

    if (targetBillList.length === 0) {
      this.$notify.error({
        title: '一括既納エラー',
        message: '既納可能な請求書が選択されていません。',
        position: 'bottom-right'
      });
      return;
    }

    try {
      const message = targetBillList.length < this.checkedBillList.length
        ? `選択中の内、${
          this.isPaypal ? 'クレジットカード・PAYPAL' : 'クレジットカード'
        }以外の既納可能な請求書（${targetBillList.length}件）を既納にします。よろしいですか？`
        : `選択中の請求書（${targetBillList.length}件）を既納にします。よろしいですか？`;

      await this.$confirm(message, '一括既納確認', {
        confirmButtonText: '一括既納',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      await Axios.post('/api/bills/bulk-payment-bill', {
        billIds: targetBillList.map((item) => item.billId),
      });

      this.clearCheckedBill();

      this.$notify.success({
        title: '一括既納完了',
        message: '一括既納しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '一括既納エラー',
        message:
          (error.response && error.response.data) || '一括既納が失敗しました。',
        position: 'bottom-right',
      });
    }

    this.loadData();
  }

  private async onBulkDeleteBill() {
    const targetBillList = this.checkedBillList
      .filter((billData) => !billData.disabled
          && (
            billData.paymentStatus !== PaymentStatusTypes.Paid
            && billData.paymentStatus !== PaymentStatusTypes.AutoPaid
          ));

    if (targetBillList.length === 0) {
      this.$notify.error({
        title: '一括削除エラー',
        message: '削除可能な請求書が選択されていません。',
        position: 'bottom-right'
      });
      return;
    }

    try {
      const message = targetBillList.length < this.checkedBillList.length
        ? `選択中の内、削除可能な請求書（${targetBillList.length}件）を削除します。よろしいですか？`
        : `選択中の請求書（${targetBillList.length}件）を削除します。よろしいですか？`;

      await this.$confirm(message, '一括削除確認', {
        confirmButtonText: '一括削除',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      await Axios.delete('/api/bills/bulk-delete-bill', {
        data: {
          billIds: targetBillList.map((item) => item.billId),
        }
      });

      this.clearCheckedBill();

      this.$notify.success({
        title: '一括削除完了',
        message: '一括削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '一括削除エラー',
        message:
          (error.response && error.response.data) || '一括削除が失敗しました。',
        position: 'bottom-right',
      });
    }

    this.loadData();
  }

  private async onChangePaymentStatus(row: BillOverviewResponse) {
    if (row.disabled) {
      return;
    }

    if (row.billStatus === BillStatusTypes.Unbilled) {
      return;
    }

    try {
      const afterValue = row.paymentStatus === PaymentStatusTypes.Paid
        ? PaymentStatusTypes.Unpaid
        : PaymentStatusTypes.Paid;

      const h = this.$createElement;
      await this.$msgbox({
        title: '支払いステータス変更',
        message: h('div', undefined, [
          h('p', undefined, `${row.studentName} 様`),
          h('p', undefined, `${moment(row.billDate).format('YYYY年MM月DD日')} 請求`),
          h('p', undefined, `の支払いステータスを「${getPaymentStatusTypeName(afterValue)}」に変更します。`),
          h('p', undefined, `よろしいですか？`)
        ]),
        showCancelButton: true,
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });

      try {
        await Axios.put(`/api/bills/${row.billId}/update-bill-status`, {
          paymentStatus: afterValue,
        });

        row.paymentStatus = afterValue;
      } catch (error) {
        this.$notify.error({
          title: '',
          message: (error.response && error.response.data) || '支払いステータスの変更が失敗しました。',
          position: 'bottom-right',
        });
      }
    } catch (error) {
      //
    }
  }
}
